var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.orderInView)?_c('OrderForm',{attrs:{"order":_vm.orderInView}}):_vm._e(),_c('div',{staticClass:"px-3"},[(_vm.orderInView)?_c('OrderDriverSearch',{attrs:{"order":_vm.orderInView}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }